import { Variants } from '@dayetopia/types';
import { ProductCode } from '@contracts';

const CBD_PRODUCT_CODES = [
  ProductCode.TamponBoxBundleRegularFlow,
  ProductCode.TamponBoxBundleRegularFlowMM,
  ProductCode.TamponBoxBundleHeavyFlow,
  ProductCode.TamponBoxBundleHeavyFlowMM,
  ProductCode.TamponBoxBundleCBD,
  ProductCode.TamponBoxRetailBundleRegularFlow,
  ProductCode.TamponBoxRetailBundleRegularFlowMM,
  ProductCode.TamponBoxRetailBundleHeavyFlow,
  ProductCode.TamponBoxRetailBundleHeavyFlowMM,
  ProductCode.TamponBoxBundleAllInOne,
  ProductCode.TamponBoxBundleAllInOneMM
] as ProductCode[];

export function tamponBoxContainsCBDTampons(productCode: ProductCode, variants?: string[]): boolean {
  // For TamponBox, we must check variants
  if (productCode === ProductCode.TamponBox) {
    // Return false if no variants provided
    if (!variants?.length) {
      return false;
    }

    // Check variants for exact CBD matches or if any variant is in CBD_PRODUCT_CODES
    return variants.some((variant) => /^cbd(regular|super)$/i.test(variant) || CBD_PRODUCT_CODES.includes(variant as ProductCode));
  }

  // Check if product code is in CBD products list
  if (CBD_PRODUCT_CODES.includes(productCode)) {
    return true;
  }

  // For other products, check for numeric cr/cs patterns in product code
  return /\d+cr|\d+cs/i.test(productCode);
}

export const getCurrentTamponsCount = (boxVariants: Variants) => {
  if (!boxVariants) return 0;
  const tamponIds = ['nakedregular', 'nakedsuper', 'cbdregular', 'cbdsuper'];
  const variantsArray = Object.entries(boxVariants);
  const tampons = Object.fromEntries(variantsArray.filter(([key]) => tamponIds.some((tamponId) => tamponId === key)));
  const tamponsCount = Object.values(tampons).length > 0 ? Object.values(tampons).reduce((total, count) => total + count) : 0;
  return Number(tamponsCount) ?? 0;
};
